export default __webpack_public_path__ + "static/P_SearchThumb_InstarVision_iOS-c8b01ad4d79371e171118fe5560000aa.webp";